"use client";

import { PddPayloadTypes } from "@/constants";
import { Context } from "@/context";
import type { StatsData } from "@/types";
import { useContext, useEffect, useState } from "react";

export const WorkerStats = () => {
  const { renderedWorker } = useContext(Context);
  const [stats, setStats] = useState<StatsData | null>(null);

  useEffect(() => {
    if (!renderedWorker) return;

    const handleMessage = ({ data: { type, payload } }: MessageEvent) => {
      if (type === PddPayloadTypes.WorkerStats) {
        setStats(payload);
      }
    };

    renderedWorker.addEventListener("message", handleMessage);

    return () => {
      renderedWorker.removeEventListener("message", handleMessage);
    };
  }, [renderedWorker]);

  if (!stats) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "3.5rem",
        left: 0,
        zIndex: 999999999999,
        pointerEvents: "none",
        fontFamily: "monospace",
        fontSize: "0.75rem",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "#0ff",
        padding: "0.5rem",
        borderRadius: "0.25rem",
      }}
    >
      {Object.entries(stats).map(([key, value]) => (
        <p key={key} style={{ margin: 0 }}>
          {key}:{" "}
          {key === "ms"
            ? value.toFixed(2)
            : key === "triangles"
              ? value.toLocaleString()
              : value}
        </p>
      ))}
    </div>
  );
};
